/**
 * Bolsa.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnumParecerSolicitacao = 1 | 2 | 3;

export const EnumParecerSolicitacao = {
    NUMBER_1: 1 as EnumParecerSolicitacao,
    NUMBER_2: 2 as EnumParecerSolicitacao,
    NUMBER_3: 3 as EnumParecerSolicitacao
};

